import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/mall/reward/list'
    return request.post(url,data)
}

export function all() {
    let url = '/mall/reward/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/mall/reward/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/mall/reward/info/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/mall/reward/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/mall/reward/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/mall/reward/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/mall/reward/dmz/options'
    return request.get(url)
}

export function upload(file) {
    let url = '/mall/reward/upload';
    let forms = new FormData()
    forms.append("file",file)
    let config = {
        headers:{'Content-Type':'multipart/form-data'}
    }; //
    return request.post(url,forms,config)
}